import arctLogo from '../../assets/Images/arctLogo-removebg-preview.png'
import carrerArcLogo from '../../assets/Images/Carrer-arc.png'
// import carrerArc2 from '../../assets/Images/Career Arc2.png'

import carrerArc2 from '../../assets/Images/CareerArc LOGO.png'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from 'react';
import { OtpInput } from '../../Component/Modal/Otp';

import '../../assets/Css/registration.css'
import { GetData, Postdata } from '../../API/GlobalApi';

import { useQr } from '../../Context/QrContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { RegistrationvalidationSchema } from '../../Utills/Schema';
import Notifier from '../../../../Utils/notify';
import Session from '../../Utills/Session';


const RegistrationForm = () => {

    const [otpModal, setOtpModal] = useState(false)
    const [otp, setOtp] = useState()
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [isOtpSending, setIsOtpSending] = useState(false);
    const navigate = useNavigate()

    const { qrCodeId, clearQrCodeId } = useQr();
    const [participantData, setParticipantData] = useState(null);


    const SentOtp = async (mobile) => {
        const url = "contest-participants/verify-mobile/";
        return await Postdata(url, { mobile });
    };



    const handeleModalOpen = async (mobile) => {
        try {
            if (!mobile) {
                Notifier.info("Please enter a contact number.");
                return;
            }
            setIsOtpSending(true); // start loading
            const response = await SentOtp(mobile);
            if (response?.otp) {
                Notifier.success(response?.detail || "OTP sent successfully");
                setOtp(response.otp);        // Set the OTP value to display
                setOtpModal(true);           // Open the modal
            } else {
                Notifier.error(response?.detail || "Failed to send OTP.");
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            Notifier.error(error?.message || "An unexpected error occurred while sending OTP.");
        } finally {
            setIsOtpSending(false); // stop loading
        }
    };



    const closeModal = () => {
        setOtpModal(false)
    }


    const initialValues = {
        name: participantData?.name || '',
        fatherName: participantData?.fatherName || '',
        previousInstitution: participantData?.previousInstitution || '',
        intermediateMarks: participantData?.intermediateMarks || '',
        mobile: participantData?.mobile || '',
        aadhaarNo: participantData?.aadhaarNo || '',
        declaration: false
    };



    const [isSubmittingForm, setIsSubmittingForm] = useState(false);


    const handleSubmit = async (values) => {
        try {
            setIsSubmittingForm(true); // ✅ start loader

            // ✅ If user already exists and hasn't paid, skip registration
            if (participantData?.payment_completed === false && participantData?.mobile === values.mobile) {
                const paymentResponse = await PaymentOpen(participantData.id || values.id);
                if (paymentResponse?.payment_url) {
                    clearQrCodeId();
                    window.location.href = paymentResponse.payment_url;
                    return;
                } else {
                    Notifier.error("Payment URL not received.");
                    return;
                }
            }

            // Normal registration flow
            const url = "contests/2/participants/";
            const payload = {
                name: values.name,
                father_name: values.fatherName,
                previous_institution: values.previousInstitution,
                intermediate_marks: values.intermediateMarks,
                mobile: values.mobile,
                aadhar: values.aadhaarNo,
                qr_code_id: 10
            };

            console.log("Sending to server:", payload);
            const response = await Postdata(url, payload);

            if (response?.id) {
                Session.set("token_arct", response?.token);
                const paymentResponse = await PaymentOpen(response.id);
                if (paymentResponse?.payment_url) {
                    clearQrCodeId();
                    window.location.href = paymentResponse.payment_url;
                } else {
                    Notifier.error("Payment URL not received.");
                }
            } else {
                Notifier.error("Registration failed. Please try again.");
            }

        } catch (error) {
            console.error("❌ Error after registration:", error);
            let backendError;
            if (Array.isArray(error)) {
                backendError = error[0];
            } else if (typeof error === "string") {
                backendError = error;
            } else if (typeof error === "object") {
                const firstKey = Object.keys(error)[0];
                const firstValue = error[firstKey];
                backendError = Array.isArray(firstValue) ? firstValue[0] : firstValue;
            }

            Notifier.error(backendError || "Something went wrong.");
        } finally {
            // ❗ Only runs if navigation does NOT happen
            setIsSubmittingForm(false);
        }
    };




    const PaymentOpen = async (participantId) => {
        // console.log("participent id", participantId)
        // console.log("participant data",participantData);
        const url = 'contest-payment-gateway/';
        const response = await Postdata(url, { participant_id: participantId });
        console.log("payment", response);
        return response;
    };



    return (
        <>

            <div className='container-fluid' style={{ background: "#F9F9F9" }}>
                <div className="row align-items-center text-center py-3">
                    {/* ARC-T Logo */}
                    <div className="col-12 col-sm-12 col-md-12 reglogo" >
                        <img src={arctLogo} style={{ width: "100%", maxWidth: "250px", height: "auto", cursor: 'pointer' }} alt="ARC-T Logo"
                        // onClick={() => navigate('/arct')}
                        />
                    </div>

                    {/* Career Arc Logo */}
                    {/* <div className="col-6 col-sm-6 col-md-6">
                        <img src={carrerArc2} style={{ width: "100%", maxWidth: "250px", height: "auto" }} alt="Career Arc Logo" />
                    </div> */}
                </div>
            </div>

            <div className='container formdetailContainer'>
                <div className="row d-flex flex-wrap mt-5">
                    {/* Left column: Registration Text */}
                    <div className="col-12 col-xl-6">
                        <p className='registration text-xl-start text-center'>REGISTRATION FORM</p>
                    </div>
                    {/* 
                    <div className="col-12 col-xl-6 d-flex justify-content-xl-end justify-content-center btncontainer">
                        <button className='registrationBtn'>ARCT 25</button>
                    </div> */}
                </div>

                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true} // ✅ reinitialize when participantData changes
                    validationSchema={RegistrationvalidationSchema}
                    onSubmit={handleSubmit}
                >
                    {(formik) => (

                        <Form className='form mt-2'>
                            {/* Row 1: Participant Name & Father's Name */}

                            {/* Row 3: Contact Number & Aadhaar */}
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xl-6 inputContainer">
                                    <div className="row d-flex align-items-center justify-content-between otprow">
                                        {/* Input - 8 columns */}
                                        <div className="col-md-7 col-sm-7 d-flex flex-column gap-2">
                                            <label htmlFor="mobile" className="form-label">Contact Number<span className="astrisk">*</span></label>
                                            <div className="input-group">
                                                <span className="input-group-text">+91</span>
                                                <Field
                                                    name="mobile"
                                                    className="form-control"
                                                    placeholder="Enter Contact Number"
                                                    disabled={isOtpVerified || formik.values.payment_completed === true}
                                                    maxLength={10}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/\D/g, ''); // remove non-digits
                                                    }}
                                                />
                                                {isOtpVerified && (
                                                    <span
                                                        className="position-absolute end-0 top-50 translate-middle-y me-3 verifiedTickm"
                                                        style={{ color: "#198754", fontSize: "1.2rem" }}  // Bootstrap green or use custom
                                                    >
                                                        ✓
                                                    </span>

                                                )}
                                            </div>
                                            <div className="text-danger" style={{ minHeight: '20px' }}>
                                                <ErrorMessage name="mobile" />
                                            </div>
                                        </div>
                                        {/* Button - 2 columns */}
                                        <div className="col-md-5 col-sm-3 otpsent">
                                            <button
                                                type="button"
                                                className="submitotp"
                                                disabled={!formik.values?.mobile || isOtpVerified}
                                                onClick={() => handeleModalOpen(formik.values.mobile)}
                                                style={{
                                                    backgroundColor: !formik.values.mobile ? '#d3d3d3' : '#DE0949',
                                                    cursor: (!formik.values.mobile || isOtpVerified) ? 'not-allowed' : 'pointer',
                                                }}
                                            >
                                                {isOtpSending ? (
                                                    <span className="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    isOtpVerified ? "Verified" : "Send OTP"
                                                )}
                                            </button>


                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-12 col-sm-12 col-xl-6 inputContainer">
                                    <label htmlFor="name" className="form-label">Participant Name<span className="astrisk">*</span></label>
                                    <Field name="name" className="form-control" placeholder="Enter Participant Name"
                                        disabled={formik.values.payment_completed === true}
                                    />
                                    <div className="text-danger"><ErrorMessage name="name" /></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xl-6 inputContainer">
                                    <label htmlFor="fatherName" className="form-label">Father’s Name<span className="astrisk">*</span></label>
                                    <Field name="fatherName" className="form-control" disabled={formik.values.payment_completed === true}
                                        placeholder="Enter Father’s Name" />
                                    <div className="text-danger"><ErrorMessage name="fatherName" /></div>
                                </div>

                                <div className="col-md-12 col-sm-12 col-xl-6 inputContainer">
                                    <label htmlFor="aadhaarNo" className="form-label">Aadhaar No.<span className="astrisk">*</span></label>
                                    <Field name="aadhaarNo" className="form-control" placeholder="Enter Aadhaar No."

                                        disabled={formik.values.payment_completed === true}

                                        maxLength={12} onInput={(e) => {
                                            e.target.value = e.target.value.replace(/\D/g, ''); // remove non-digits
                                        }} />
                                    <div className="text-danger"><ErrorMessage name="aadhaarNo" /></div>
                                </div>
                            </div>

                            {/* Row 2: Previous Institution & Marks */}
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xl-8 inputContainer">
                                    <label htmlFor="previousInstitution" className="form-label">School Name<span className="astrisk">*</span></label>
                                    <Field name="previousInstitution"
                                        disabled={formik.values.payment_completed === true}

                                        className="form-control" placeholder="School Name" />
                                    <div className="text-danger"><ErrorMessage name="previousInstitution" /></div>
                                </div>
                                <div className="col-md-12 col-sm-12 col-xl-4 inputContainer">
                                    <label htmlFor="intermediateMarks" className="form-label">Marks Obtained in Intermediate in (%)</label>
                                    <Field name="intermediateMarks" className="form-control" placeholder="Enter Marks"
                                        disabled={formik.values.payment_completed === true}
                                        maxLength={3}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/\D/g, ''); // remove non-digits
                                        }}
                                    />
                                    <div className="text-danger"><ErrorMessage name="intermediateMarks" /></div>
                                </div>
                            </div>

                            <div className="row mb-3 d-flex gap-3">
                                <div className="col-md-12 col-sm-12 col-xl-12 ">
                                    <p className='eligibility'>Eligibility: Only Student appearing/passed 10+2 are eligible to register</p>
                                    <p className='eligibility mb-0 declaration' >Declaration:</p>
                                </div>
                                {/* Declaration Section */}

                                <div className="col-12">
                                    {/* <label className="form-label fw-bold text-danger">Declaration:</label> */}
                                    <div className="form-check">

                                        <Field
                                            type="checkbox"
                                            name="declaration"
                                            className="form-check-input"
                                            id="declaration"
                                            disabled={participantData?.participant === null}
                                        />
                                        <label className="form-check-label ms-2 declaration" htmlFor="declaration">
                                            I hereby declare that the information provided above is true and correct to the best of my knowledge.
                                            I agree to follow the rules and guidelines set by the organizers of
                                            <strong className='strongText'> Aptitude & Reasoning Challenge Test (ARC-T 2.0)</strong>
                                        </label>
                                    </div>
                                    <div className="text-danger"><ErrorMessage name="declaration" /></div>
                                </div>


                            </div>

                            {/* Submit Button */}
                            <div className="text-center mb-5">
                                <button type="submit" className="submit" disabled={participantData?.payment_completed === true}

                                    style={{
                                        backgroundColor: participantData?.payment_completed === true ? '#d3d3d3' : '#DE0949',
                                        cursor: participantData?.payment_completed === true ? 'not-allowed' : 'pointer',
                                    }}
                                >
                                    {isSubmittingForm ? (
                                        <span className="spinner-border spinner-border-sm text-light" />
                                    ) : (
                                        participantData?.payment_completed === false ? "Make Payment" : "Submit"
                                    )}
                                </button>
                            </div>
                            <OtpInput
                                isOpen={otpModal}
                                onClose={closeModal}
                                // onVerified={() => setIsOtpVerified(true)}
                                onVerified={(userDetails) => {
                                    setParticipantData(userDetails);
                                    setIsOtpVerified(true)
                                    // Automatically fill form using Formik
                                    for (const key in userDetails) {
                                        formik.setFieldValue(key, userDetails[key]);
                                    }
                                }}
                                setOtpText={setOtp}
                                otptext={otp} mobile={formik.values.mobile} />
                        </Form>

                    )}
                </Formik>

            </div>

        </>

    )
}

export default RegistrationForm